import clsx from 'clsx';
import React from 'react';

import styles from './SectionContainer.module.scss';

interface SectionContainerProps {
  children: React.ReactNode;
  className?: string;
}

const SectionContainer = React.forwardRef<HTMLDivElement, SectionContainerProps>(
  ({ children, className }, ref) => {
    return (
      <div className={clsx(styles.sectionContainer, className)} ref={ref}>
        {children}
      </div>
    );
  },
);

SectionContainer.displayName = 'SectionContainer';

export default SectionContainer;
